export const lisencesAndCertificates = [
  {
    id: 1,
    title: "Javascript for Web Designers",
    issuer: "lynda.com",
    issued: "July 2018",
    expiry: null,
    credential: "53C44E",
    link: require("@/assets/certificate/lynda.svg"),
    certificate:
      "https://www.lynda.com/home/CertificateOfCompletion/PrintCertificate.aspx?lpk57=53C44E87BB3C44408D0925BEA0D7C43C"
  },
  {
    id: 2,
    title: "Adobe XD First Look",
    issuer: "lynda.com",
    issued: "June 2018",
    expiry: null,
    credential: "27885E",
    link: require("@/assets/certificate/lynda.svg"),
    certificate:
      "https://www.lynda.com/home/CertificateOfCompletion/PrintCertificate.aspx?lpk57=27885E8147F64E86B9FA11182C014033"
  },
  {
    id: 3,
    title: "Bootstrap 3: Customizing with LESS",
    issuer: "lynda.com",
    issued: "June 2018",
    expiry: null,
    credential: "DB8185",
    link: require("@/assets/certificate/lynda.svg"),
    certificate:
      "https://www.lynda.com/home/CertificateOfCompletion/PrintCertificate.aspx?lpk57=DB818585A62C4038B90D0C9667C9DA91"
  },
  {
    id: 4,
    title: "CSS with LESS and Sass",
    issuer: "lynda.com",
    issued: "June 2018",
    expiry: null,
    credential: " 4393AD",
    link: require("@/assets/certificate/lynda.svg"),
    certificate:
      "https://www.lynda.com/home/CertificateOfCompletion/PrintCertificate.aspx?lpk57=4393AD5D82FF4069AA90B26E2D9375CA"
  },
  {
    id: 5,
    title: "Illustrator for Web Design",
    issuer: "lynda.com",
    issued: "June 2018",
    expiry: null,
    credential: "FBD9C6",
    link: require("@/assets/certificate/lynda.svg"),
    certificate:
      "https://www.lynda.com/home/CertificateOfCompletion/PrintCertificate.aspx?lpk57=FBD9C6559C4D4378963DF648A344E80E"
  },
  {
    id: 6,
    title: "Learning Vue.js",
    issuer: "lynda.com",
    issued: "June 2018",
    expiry: null,
    credential: "6C49E3",
    link: require("@/assets/certificate/lynda.svg"),
    certificate:
      "https://www.lynda.com/home/CertificateOfCompletion/PrintCertificate.aspx?lpk57=6C49E3E9E0034A7FBC75D9C7F6086791"
  },
  {
    id: 7,
    title: "Learning Webpack 3",
    issuer: "lynda.com",
    issued: "June 2018",
    expiry: null,
    credential: "9F8464",
    link: require("@/assets/certificate/lynda.svg"),
    certificate:
      "https://www.lynda.com/home/CertificateOfCompletion/PrintCertificate.aspx?lpk57=9F8464BBEFDD4E65930663848ACA94FB"
  },
  {
    id: 8,
    title: "Vue.js: Building an Interface",
    issuer: "lynda.com",
    issued: "June 2018",
    expiry: null,
    credential: "5A5A7E",
    link: require("@/assets/certificate/lynda.svg"),
    certificate:
      "https://www.lynda.com/home/CertificateOfCompletion/PrintCertificate.aspx?lpk57=5A5A7E1A496242BEB3EA739D65B5FB6D"
  },
  {
    id: 9,
    title: "Oracle Certified Java Programmer",
    issuer: "Oracle",
    issued: "April 2013",
    expiry: null,
    credential: "OC1221631",
    link: require("@/assets/certificate/oracle.svg"),
    certificate:
      "https://drive.google.com/open?id=1oRDVq4JTNfxVNpmrgbN0vvS1FOB-1J7I"
  },
  {
    id: 10,
    title: "Avanced Java",
    issuer: "Aptech",
    issued: "August 2011",
    expiry: null,
    credential: null,
    link: require("@/assets/certificate/aptech.svg"),
    certificate: null
  }
];
